<template>
  <div>
    <h6 class="font-semibold my-20">
      {{
        $route.params.id ? "Cập nhật package" : "Thêm mới package"
      }}
    </h6>
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tên dự án" prop="name">
          <a-input v-model="form.name" placeholder="Tên dự án" />
        </a-form-model-item>
         <a-form-model-item class="mb-5" label="Slug" prop="slug">
          <a-input v-model="form.slug" class="w-full"  placeholder="Slug" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Mô tả ngắn" prop="short_description">
          <a-input v-model="form.short_description" placeholder="Mô tả ngắn" />
        </a-form-model-item>
        <a-form-model-item
          class="mb-5"
          label="Loại dự án"
          prop="field_project_id"
        >
          <a-select
            v-model="form.field_project_id"
            class="w-full"
            placeholder="Chọn"
            show-search
            allowClear
            option-filter-prop="children"
          >
            <a-select-option
              v-for="item in productOptions"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Trạng thái hiển thị" prop="active">
            <a-switch default-checked v-model="form.active" />
        </a-form-model-item>
        <a-form-model-item class="mb-30" label="Ảnh" :colon="false">
          <input
            type="file"
            accept="image/png, image/svg, image/jpeg, image/gif, image/jpg"
            @change="onAvatarChange"
          />
        </a-form-model-item>
        <img
          v-show="currentAvatar || avatarUrl"
          id="preview-avatar"
          :src="avatarUrl"
          class="preview-avatar"
        />
        <a-form-model-item
          class="mb-5"
          label="Nội dung"
          prop="description"
        >
          <ckeditor :editor="editor" v-model="form.description" :height="500" :config="editorConfig"></ckeditor>
        </a-form-model-item>
        <a-row type="flex" justify="end" class="mt-20">
          <a-button type="primary" :loading="callingAPI" @click="handleSubmit">
            {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
          </a-button>
        </a-row>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import {
  fetchProjectById,
  updateProject,
  createProject
} from "@/services/landing-page/project";
import { upload } from '@/services/landing-page/storage'
import { fetchProduct } from '@/services/landing-page/home/product'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ENDPOINT from '@/config/endpoint'

export default {
  name: "PackageController",
  data() {
    return {
      callingAPI: false,
      editor: ClassicEditor,
      editorConfig: {
        height: 500
      },
      currentAvatar: null,
      avatarUrl: "",
      productOptions: [],
      form: {
        name: "",
        slug: "",
        short_description: "",
        description: "",
        photo_url: '',
        field_project_id: null,
        active: true,
      },
      rules: {
        name: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        slug: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
         short_description: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        description: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
         field_project_id: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ]
      }
    }
  },
  async created() {
    await this.getProductOptions()
    if (this.$route.params.id) {
      await this.loadData();
    }
  },
  methods: {

    async loadData() {
      try {
        const response = await fetchProjectById(this.$route.params.id);
        for (var key in this.form) {
          if (response.data.hasOwnProperty(key)) {
            if (key === 'active') {
               this.form[key] = response.data[key] === 1 ? true : false
            } else {
              this.form[key] = response.data[key];
            }
          }
        }
        this.avatarUrl = `${ENDPOINT.BACKEND_URL}${response?.data?.photo_url}`
      } catch (error) {}
    },
    async handleSubmit() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            this.callingAPI = true;
            if (this.currentAvatar) {
              await this.handleUploadAvatar();
            }
            if (!this.form.photo_url) {
              this.$message.error('Vui lòng upload ảnh đại diện!');
              this.callingAPI = false
              return;
            }
            const data = {
              ...this.form,
              active: this.form.active ? 1 : 0
            };

           const response = this.$route.params.id ? await updateProject(this.$route.params.id, data) :  await createProject(data);
           this.callingAPI = false;
            if (response.status == 1) {
              const message = this.$route.params.id
                ? "Cập nhật thành công."
                : "Thêm mới thành công.";
              this.$notification.success({
                message: "Thành công",
                description: message,
              });
              this.$router.push({path: "/our-bussiness/projects"})
            } else {
              this.$notification.error({
                message: "Thất bại",
                description: response.errors[0],
              });
            }
          }
        });
      } catch (error) {
        this.callingAPI = false;
        let message = this.$route.params.id
          ? "Cập nhật thất bại"
          : "Thêm mới thất bại";
        this.$notification.error({
          message: "Thất bại",
          description: message
        });
      }
    },
    async getProductOptions() {
      try {
        const response = await fetchProduct()
        this.productOptions = response?.data?.filter(item => item.type !== 1 && item.high_light !== 1).map(item => ({ id: item.id, name: item.name })) || [];
      } catch (error) {}
    },
    onAvatarChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.currentAvatar = file;
        this.avatarUrl = URL.createObjectURL(file);
      }
    },
    async handleUploadAvatar() {
      try {
        const formData = new FormData()
        formData.append('type', 'ckeditor')
        formData.append('upload', this.currentAvatar)
        formData.append("position_type", "1");

        const response = await upload(formData)
        this.form.photo_url = response.data[0].path;
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
</style>